import { db, doc, setDoc } from '../firebase';

/**
 * Utility function to set up the version configuration in Firestore
 * Run this once to create the initial config document
 */
export const setupVersionConfig = async (requiredVersion = '1.0.0') => {
  try {
    const configDoc = doc(db, 'config', 'app');
    await setDoc(configDoc, {
      requiredVersion: requiredVersion,
      currentVersion: requiredVersion, // Set current version same as required initially
      lastUpdated: new Date().toISOString()
    });
    console.log(`✅ Version config set up successfully with requiredVersion: ${requiredVersion}`);
  } catch (error) {
    console.error('❌ Error setting up version config:', error);
  }
};

/**
 * Test function to update the required version
 * Use this to test the version gate functionality
 */
export const updateRequiredVersion = async (newVersion) => {
  try {
    const configDoc = doc(db, 'config', 'app');
    await setDoc(configDoc, {
      requiredVersion: newVersion,
      lastUpdated: new Date().toISOString()
    }, { merge: true }); // Use merge to preserve existing fields
    console.log(`✅ Required version updated to: ${newVersion}`);
  } catch (error) {
    console.error('❌ Error updating required version:', error);
  }
};

/**
 * Function to update the current app version
 * Use this to update the current version in Firestore
 */
export const updateCurrentVersion = async (newVersion) => {
  try {
    const configDoc = doc(db, 'config', 'app');
    await setDoc(configDoc, {
      currentVersion: newVersion,
      lastUpdated: new Date().toISOString()
    }, { merge: true }); // Use merge to preserve existing fields
    console.log(`✅ Current version updated to: ${newVersion}`);
  } catch (error) {
    console.error('❌ Error updating current version:', error);
  }
};

// Example usage:
// setupVersionConfig('1.0.0'); // Set initial version
// updateRequiredVersion('1.1.0'); // Test with newer version 